import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { fromJS, List } from "immutable";
import { getSampleSchema } from "./utils";
import { getKnownSyntaxHighlighterLanguage } from "./utils/jsonParse";
import * as ace from "brace";
import "ace-builds/webpack-resolver";
import AceEditor from "react-ace";
import "brace/mode/json";
import "brace/mode/xml";
import "brace/theme/github";
import { profiles } from "../App";

const NOOP = Function.prototype;

export default class AceParamBody extends PureComponent {
  static propTypes = {
    param: PropTypes.object,
    onChange: PropTypes.func,
    onChangeConsumes: PropTypes.func,
    consumes: PropTypes.object,
    consumesValue: PropTypes.string,
    fn: PropTypes.object.isRequired,
    getConfigs: PropTypes.func.isRequired,
    getComponent: PropTypes.func.isRequired,
    isExecute: PropTypes.bool,
    specSelectors: PropTypes.object.isRequired,
    pathMethod: PropTypes.array.isRequired,
  };

  static defaultProp = {
    consumes: fromJS(["application/json"]),
    param: fromJS({}),
    onChange: NOOP,
    onChangeConsumes: NOOP,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      isEditBox: false,
      value: "",
      profile: Object.keys(profiles)[0],
    };
  }

  componentDidMount() {
    this.updateValues.call(this, this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateValues.call(this, nextProps);
  }

  updateValues = (props) => {
    let { param, isExecute, consumesValue = "" } = props;
    let isXml = /xml/i.test(consumesValue);
    let isJson = /json/i.test(consumesValue);
    let contentTypeChanged = this.props.consumesValue != props.consumesValue;
    let paramValue = isXml ? param.get("value_xml") : param.get("value");
    if (paramValue === undefined || contentTypeChanged) {
      if (isXml) {
        this.onChange(this.sample("xml"), {
          isXml: isXml,
          isEditBox: isExecute,
        });
      } else {
        this.onChange(this.sample(), { isEditBox: isExecute });
      }
    } else {
      let val = !paramValue && isJson ? "{}" : paramValue;
      this.setState({ value: val });
      this.onChange(val, { isXml: isXml, isEditBox: isExecute });
    }
  };

  sample = (xml) => {
    if (this.state.profile) {
      if (xml) {
        return profiles[this.state.profile]["xml"];
      } else {
        return profiles[this.state.profile]["json"];
      }
    }

    let {
      param,
      fn: { inferSchema },
    } = this.props;
    let schema = inferSchema(param.toJS());

    return getSampleSchema(schema, xml, {
      includeWriteOnly: true,
    });
  };

  onChange = (value, { isEditBox, isXml }) => {
    this.setState({ value, isEditBox });
    this._onChange(value, isXml);
  };

  _onChange = (val, isXml) => {
    (this.props.onChange || NOOP)(val, isXml);
  };

  handleOnChange = (v) => {
    const { consumesValue } = this.props;
    const isXml = /xml/i.test(consumesValue);
    const inputValue = v;
    this.onChange(inputValue, { isEditBox: this.state.isEditBox, isXml });
  };

  onChangeProfile = (profile, contentType) => {
    if (this.state.profile != profile) {
      this._onChange(profiles[profile][contentType], contentType == "xml");
    }
    this.setState({ profile: profile });
  };

  toggleIsEditBox = () =>
    this.setState((state) => ({ isEditBox: !state.isEditBox }));

  render() {
    let {
      onChangeConsumes,
      param,
      isExecute,
      specSelectors,
      pathMethod,
      getConfigs,
      getComponent,
    } = this.props;

    const ContentType = getComponent("contentType");
    const ProfileSelector = getComponent("profileSelector");
    // for domains where specSelectors not passed
    let parameter = specSelectors
      ? specSelectors.parameterWithMetaByIdentity(pathMethod, param)
      : param;
    let consumesValue = specSelectors
      .contentTypeValues(pathMethod)
      .get("requestContentType");
    let consumes =
      this.props.consumes && this.props.consumes.size
        ? this.props.consumes
        : AceParamBody.defaultProp.consumes;

    let { value, isEditBox } = this.state;
    let language = null;
    let testValueForJson = getKnownSyntaxHighlighterLanguage(value);
    if (testValueForJson) {
      language = "json";
    }

    return (
      <div
        className="body-param"
        data-param-name={param.get("name")}
        data-param-in={param.get("in")}
      >
        <AceEditor
          className={"body-param__text"}
          width="100%"
          value={value}
          mode={
            !consumesValue || consumesValue.includes("json") ? "json" : "xml"
          }
          theme="github"
          readOnly={!isExecute}
          onChange={this.handleOnChange}
          highlightActiveLine={true}
          setOptions={{ useWorker: true }}
          editorProps={{ $blockScrolling: true }}
        />

        <div className="body-param-options">
          <label htmlFor="">
            <span>Profile</span>
            <ProfileSelector
              value={this.state.profile}
              onChange={(e) =>
                this.onChangeProfile(
                  e,
                  !consumesValue || consumesValue.includes("json")
                    ? "json"
                    : "xml"
                )
              }
              profile={fromJS(Object.keys(profiles))}
              className="body-param-content-type"
              ariaLabel="Parameter content type"
            />
          </label>
        </div>

        <div className="body-param-options">
          <label htmlFor="">
            <span>Parameter content type</span>
            <ContentType
              value={consumesValue}
              contentTypes={consumes}
              onChange={onChangeConsumes}
              className="body-param-content-type"
              ariaLabel="Parameter content type"
            />
          </label>
        </div>
      </div>
    );
  }
}
